// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3U7xF","footer":"ReportModalFilter_footer__3Nv8W"};